<template>
  <div>
    <div class="container-fluid bg-light py-6 mt-0">
      <div class="container text-center animated bounceInDown">
        <h1 class="display-1 mb-4">{{ $t('contact') }}</h1>
        <ol
          class="breadcrumb justify-content-center mb-0 animated bounceInDown"
        >
          <li class="breadcrumb-item"><a href="#">{{ $t('home') }}</a></li>
          <li class="breadcrumb-item text-dark" aria-current="page">
            {{ $t('contact') }}
          </li>
        </ol>
      </div>
    </div>
    <div
      class="container-fluid contact py-6 wow bounceInUp"
      data-wow-delay="0.1s"
    >
      <div class="container">
        <div class="p-5 bg-light rounded contact-form">
          <div class="row g-4">
            <div class="col-12">
              <small
                class="d-inline-block fw-bold text-dark text-uppercase bg-light border border-primary rounded-pill px-4 py-1 mb-3"
                >{{ $t('getInTouch') }}</small
              >
              <h1 class="display-5 mb-0">{{ $t('contactPageTitle') }}</h1>
            </div>
            <div class="col-md-6 col-lg-7">
              <form @submit.prevent="submitForm">
                <input
                  type="text"
                  v-model="form.name"
                  class="w-100 form-control p-3 mb-4 border-primary bg-light"
                  placeholder="Your Name"
                />
                <input
                  type="email"
                  v-model="form.email"
                  class="w-100 form-control p-3 mb-4 border-primary bg-light"
                  placeholder="Enter Your Email"
                />
                <textarea
                  v-model="form.message"
                  class="w-100 form-control mb-4 p-3 border-primary bg-light"
                  rows="4"
                  cols="10"
                  placeholder="Your Message"
                ></textarea>
                <button
                  class="w-100 btn btn-primary form-control p-3 border-primary bg-primary rounded-pill"
                  type="submit"
                >
                  Submit Now
                </button>
              </form>
            </div>
            <div class="col-md-6 col-lg-5">
              <div>
                <div
                  class="d-inline-flex w-100 border border-primary p-4 rounded mb-4"
                >
                  <i class="fas fa-map-marker-alt fa-2x text-primary me-4"></i>
                  <div class="">
                    <h4>{{ $t('address') }}</h4>
                    <p>
                      No.125,Tagaung 8th street,5 ward , South Okkalapa Township,
                      Yangon, Myanmar
                    </p>
                  </div>
                </div>
                <div
                  class="d-inline-flex w-100 border border-primary p-4 rounded mb-4"
                >
                  <i class="fas fa-envelope fa-2x text-primary me-4"></i>
                  <div class="">
                    <h4>{{ $t('mailTo') }}</h4>
                    <p class="mb-2">kaimyanmar2018@gmail.com</p>
                  </div>
                </div>
                <div
                  class="d-inline-flex w-100 border border-primary p-4 rounded"
                >
                  <i class="fa fa-phone-alt fa-2x text-primary me-4"></i>
                  <div class="">
                    <h4>{{ $t('telephone') }}</h4>
                    <p class="mb-2">+95 9 44022 8711, 09404437173</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

export default {
  data() {
    return {
      form: {
        name: '',
        email: '',
        subject: 'Contact Form Submission',
        message: ''
      }
    };
  },
  methods: {
    async submitForm() {
      try {
        const response = await axios.post('http://localhost:8000/api/send-email', { // Replace with your backend URL
          name: this.form.name,
          email: this.form.email,
          subject: this.form.subject,
          message: this.form.message,
        });
        alert(response.data.message);
      } catch (error) {
        console.error('Error sending email:', error);
        alert('Failed to send email.');
      }
    }
  }
};
</script>

<style></style>
